import React, { useContext, useMemo } from "react";

const TypesContext = React.createContext({});

const TypesProvider = ({ value, ...props }) => {
  const types = useMemo(() => {
    return value.reduce((accumulator, currentValue) => ({
      ...accumulator,
      [currentValue.replace("TASKTYPE_", "")]: currentValue,
    }), {});
  }, [value]);

  return (
    <TypesContext.Provider
      {...props}
      value={types}
    />
  );
};

export const useTypes = () => {
  const context = useContext(TypesContext);

  if (context === undefined) {
    throw new Error("useTypes must be used within a TypesProvider");
  }

  return context;
};

export default TypesProvider;
